import React from 'react';
import { Form } from 'react-bootstrap';

import {
  getJianyingTextMetrics,
  isJianyingTextMetricOverLimit,
} from '@/features/automation/jianying/utils/jianyingSlots.js';

const getFieldId = (slotId) => (
  `jianying-text-${String(slotId).replace(/[^a-zA-Z0-9_-]/g, '-')}`
);

export const JianyingTextField = ({
  disabled,
  errors: directErrors,
  fieldErrors = {},
  onChange,
  registerFieldRef,
  slot,
  value,
}) => {
  const text = typeof value === 'string' || typeof value === 'number'
    ? String(value)
    : String(value?.text ?? value?.content ?? value?.value ?? '');
  const metrics = getJianyingTextMetrics(text);
  const overLimit = isJianyingTextMetricOverLimit(slot, metrics);
  const errors = directErrors || fieldErrors[slot.id] || [];
  const isMultiline = slot.runtime?.input_mode === 'multiline';
  const fieldId = getFieldId(slot.id);
  const errorId = `${fieldId}-errors`;
  const controlProps = {
    id: fieldId,
    disabled,
    placeholder: slot.aiCaptionDefault ? '还未生成文案' : undefined,
    value: text,
    isInvalid: errors.length > 0,
    'aria-describedby': errors.length ? errorId : undefined,
    ref: (node) => registerFieldRef?.(slot.id, node),
    onChange: (event) => onChange(slot.id, event.target.value),
  };

  return (
    <Form.Group className="jianying-text-field">
      <div className="jianying-text-field__label">
        <Form.Label htmlFor={fieldId}>{slot.name}{slot.required ? <span aria-hidden="true"> *</span> : null}</Form.Label>
      </div>
      {isMultiline ? <Form.Control {...controlProps} as="textarea" rows={4} /> : <Form.Control {...controlProps} type="text" />}
      <div className="jianying-text-field__metrics" aria-live="polite">
        <span className={overLimit.characters ? 'is-over-limit' : ''}> {slot.runtime?.max_length === undefined ? '不限' : `${metrics.characterCount}/${slot.runtime?.max_length} 字`}</span>
        {isMultiline ? <span className={overLimit.lines ? 'is-over-limit' : ''}> {slot.runtime?.max_lines === undefined ? '不限' : `${metrics.lineCount}/${slot.runtime?.max_lines} 行`}</span> : null}
      </div>
      {errors.length ? <div id={errorId} className="jianying-text-field__errors" role="alert">{errors.map((error) => <div key={error}>{error}</div>)}</div> : null}
    </Form.Group>
  );
};
